export default function GeneralHeaderSection(props) {
  const { title } = props;

  return (
    <div className="bg-white border-custom-b-1 border-gray-900 text-center py-2">
      <p className="text-xl">{title}</p>
    </div>
  );
}
